import { CommonButton } from 'components/Buttons';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import actions from 'state/actions';
import selectors from 'state/selectors';
import utils from 'utils';
import { actionType, modalActionType } from 'utils/constants';
import useCheckBeforeAction from '../hooks';

interface Props {
  isLitigationPark?: boolean;
}

const LitigationArchive = (props: Props) => {
  const { isLitigationPark } = props;

  const records = useSelector(selectors.documents.selectAllActiveDocuments);
  const dispatch = useDispatch();
  const t = utils.intl.useTranslator();
  const saveDocument = utils.hooks.useSaveDocument();
  const { checkDocuments } = useCheckBeforeAction(actionType.LITIGATION_ARCHIVE);
  const onClick = async () => {
    const docFree = await checkDocuments();
    if (!docFree) return;
    if ((await saveDocument()) === null) {
      return;
    }
    dispatch(actions.modal.openModal(modalActionType.documents.LITIGATION, { type: 'archive', isLitigationPark }));
  };
  return (
    <CommonButton
      id="litigation-archive-btn"
      action={onClick}
      customIcon="archive"
      scope="tertiary"
      value={t(isLitigationPark ? 'archivia' : 'archivia1')}
      disabled={
        !utils.user.isActionEnabled(
          records,
          isLitigationPark ? actionType.LITIGATION_PARK_ARCHIVE : actionType.LITIGATION_ARCHIVE,
        )
      }
    />
  );
};

export default LitigationArchive;
